// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3RvUz","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2OS9U","obliqueLine":"membershipbadge_obliqueLine__19XcD"};